module.exports = __webpack_public_path__ + "img/icon_menu_sp_uriage3.5e340b15.png";